module.exports = __webpack_public_path__ + "static/media/lapin1rose.f85fa87e.png";